import { render, staticRenderFns } from "./Money.vue?vue&type=template&id=7a3a5572&scoped=true"
import script from "./Money.vue?vue&type=script&lang=js"
export * from "./Money.vue?vue&type=script&lang=js"
import style0 from "./Money.vue?vue&type=style&index=0&id=7a3a5572&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3a5572",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a3a5572')) {
      api.createRecord('7a3a5572', component.options)
    } else {
      api.reload('7a3a5572', component.options)
    }
    module.hot.accept("./Money.vue?vue&type=template&id=7a3a5572&scoped=true", function () {
      api.rerender('7a3a5572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/common/Money.vue"
export default component.exports